module.exports = __webpack_public_path__ + "static/diesel-9ad283ea46bc19d338f1987dd60f7e65.png";